import { Crown } from "lucide-react";

export const InternalBadge = ({ c, id }) => (c?.internal ? (
  <span className="text-[10px] font-bold tracking-wider px-1.5 py-0.5 rounded-sm bg-emerald-100 text-emerald-800 border border-emerald-300 truncate" data-testid={id}>
    INTERNAL{c.internal_member ? ` · ${c.internal_member}` : ""}
  </span>
) : null);

export const CHANNEL_LABEL = { web: "Web (internal)", website: "Website", whatsapp: "WhatsApp", email: "Email", telegram: "Telegram" };
export const STATUS_LABEL = {
  open: "Diproses", waiting_approval: "Menunggu Approval", waiting_customer: "Menunggu Customer", closed: "Selesai",
};
const PRIORITY_CLS = { urgent: "bg-red-100 text-red-700", high: "bg-orange-100 text-orange-700", normal: "bg-secondary text-foreground", low: "bg-secondary text-muted-foreground" };

export function TeamStrip({ agents, director, active }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2" data-testid="agent-team-strip">
      {agents.map((a) => (
        <div key={a.key} data-testid={`team-agent-${a.key}`}
          className={`border rounded-sm p-2.5 transition-colors duration-300 ${active === a.key ? "border-accent bg-accent/10" : "border-border bg-card"}`}>
          <div className="flex items-center gap-1.5">
            <span className={`w-5 h-5 rounded-sm text-[10px] font-bold flex items-center justify-center ${active === a.key ? "bg-accent text-accent-foreground" : "bg-secondary"}`}>{a.no}</span>
            <span className="font-heading font-bold text-sm">{a.name}</span>
            {active === a.key && <span className="ml-auto w-2 h-2 rounded-full bg-accent animate-pulse" />}
          </div>
          <div className="text-[10px] text-muted-foreground mt-1 leading-tight">{a.role}</div>
        </div>
      ))}
      <div className="border border-amber-300 bg-amber-50 rounded-sm p-2.5" data-testid="team-director">
        <div className="flex items-center gap-1.5"><Crown className="w-4 h-4 text-amber-600" /><span className="font-heading font-bold text-sm">Direktur</span>{" "}</div>
        <div className="text-[10px] text-amber-800 mt-1 leading-tight">{director}</div>
      </div>
    </div>
  );
}

export function CaseMeta({ c, agents }) {
  if (!c?.case_number) {
    return <div className="border border-dashed border-border rounded-sm p-5 text-sm text-muted-foreground" data-testid="case-meta-empty">Case ID dibuat otomatis oleh Nadia saat pesan pertama masuk.</div>;
  }
  const agent = agents.find((a) => a.key === c.current_agent);
  const rows = [
    ["Case ID", <span className="font-mono text-primary">{c.case_number}</span>],
    ["Kanal", CHANNEL_LABEL[c.channel]],
    ["Jalur", c.track === "sales" ? "Sales Opportunity" : c.track === "service" ? "Service / Complaint" : "—"],
    ["Prioritas", <span className={`px-1.5 py-0.5 rounded-sm text-xs ${PRIORITY_CLS[c.priority]}`}>{c.priority}</span>],
    ["Status", STATUS_LABEL[c.status] || c.status],
    ["Ditangani", agent ? `${agent.name} · ${agent.role}` : "-"],
    ["SLA", (c.sla_due || "").slice(0, 16).replace("T", " ")],
    ["Customer", c.customer_company || c.customer_name || c.customer_phone || "-"],
    ...(c.internal ? [["Permintaan", <InternalBadge c={c} id="case-meta-internal-badge" />]] : []),
  ];
  return (
    <div className="border border-border bg-card rounded-sm p-4 space-y-3" data-testid="case-meta">
      <div className="space-y-1.5 text-sm">
        {rows.map(([k, v]) => (
          <div key={k} className="flex justify-between gap-3"><span className="text-muted-foreground text-xs">{k}</span><span className="text-right">{v}</span></div>
        ))}
      </div>
      {c.summary && <div className="text-xs bg-secondary rounded-sm p-2.5 leading-relaxed" data-testid="case-summary">{c.summary}</div>}
      {c.handoffs?.length > 0 && (
        <div className="text-xs space-y-1" data-testid="case-handoffs">
          <div className="overline text-muted-foreground">Alur Handoff</div>
          {c.handoffs.map((h, i) => <div key={i}>{h.from} → <b>{h.to}</b></div>)}
        </div>
      )}
      {c.bom?.length > 0 && (
        <div className="text-xs space-y-1" data-testid="case-bom">
          <div className="overline text-muted-foreground">BOM (Rara)</div>
          {c.bom.map((b, i) => <div key={i}>{b.quantity}x {b.product_name}</div>)}
        </div>
      )}
      {c.po?.po_number && <div className="text-xs" data-testid="case-po">PO diterima: <b>{c.po.po_number}</b></div>}
    </div>
  );
}
